import { FetchProfileType } from '../redux/lounges/slice';
import { GET_BASE_URL } from '../constants/apiEndpoints';
import { readLoungeAuthorizedData } from '../utils/loungeAuthRefresh';

export const getProfileApi = async ({ key: _key }: FetchProfileType) => {
  return readLoungeAuthorizedData(
    GET_BASE_URL + '/api/v1/getProfile',
    'getProfile'
  );
};
